import { BrowserView } from 'components/DeviceDetect'
import { ArrowRight } from 'components/Icons'
import CountDown from 'components/CountDown/RoundedCountDown'
import React from 'react'
import {
  SectionHeading,
  SectionHeadingH1,
  SectionLink,
  SectionWithHeading,
} from './SectionBlock.style'

const SectionBlock = props => {
  const {
    title,
    countdown,
    linkText,
    link,
    titleComponent,
    children,
    ...rest
  } = props

  const TComponent = titleComponent === 'h1' ? SectionHeadingH1 : SectionHeading

  return (
    <SectionWithHeading {...rest}>
      {(title || linkText) && (
        <TComponent>
          <span>
            {title}
            {countdown && (
              <BrowserView>
                <CountDown
                  type="rounded"
                  date={countdown}
                  className="desktop-countdown"
                />
              </BrowserView>
            )}
          </span>
          {link && linkText && (
            <SectionLink to={link || '#'}>
              {linkText}
              <ArrowRight color="black2" />
            </SectionLink>
          )}
        </TComponent>
      )}
      {children}
    </SectionWithHeading>
  )
}

export default SectionBlock
